<style lang="less">
</style>

<template>
  <el-card>
    <el-form inline :model="query" class="filter-form">
      <el-col :span="16">
        <el-form-item label="关键词名称">
          <el-input v-model.trim="query.keyword" placeholder="请输入关键词名称" style="width: 300px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryCollection">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-col>
    </el-form>
    <el-table class="table block" :header-cell-style="tableHeaderStyle" v-loading="loading" :data="collection">
      <el-table-column align="center" prop="keyword" label="关键词名称" />
      <el-table-column align="center" prop="count" label="搜索次数" />
    </el-table>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
  </el-card>
</template>

<script>

import { actionClient } from '@/api'

export default {
  data() {
    return {
      query: {},
      loading: false,
      pagination: null,
      total: 0,
      collection: []
    };
  },
  computed: {
  },

  async mounted() {
    await this.queryCollection()
  },
  methods: {
    reset() {
      this.query = {}
      this.queryCollection()
    },
    async queryCollection({ pagination = {} } = {}) {
      const query = {
        keyword: this.query.keyword || undefined, // 设为模糊搜索
       ...pagination
      }
      try {
        this.loading = true
        let data = await actionClient.get('/search-log', { query })
        this.collection = data.data
        this.total = data.total
        this.pagination = { ...data, currentPage: data.current_page }
      } finally {
        this.loading = false
      }
    },

    tableHeaderStyle() {
      return "color:#000;font-wight:500;font-size:16px;height:60px;background-color:#e6e9f2;";
    },
  },
};
</script>
